import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/sagas/funnelChart";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

export function OptInFilter() {
  const dispatch = useDispatch();

  const startFrom = useSelector((state) => state.laser.selectedFilters.startFrom.id);

  const options = useSelector((state) => state.laser.optInOptions);
  const selected = useSelector((state) => state.laser.selectedFilters.optInFilters);

  const showFilter = startFrom === "leads";

  return showFilter ? (
    <div className="select-box" style={{ width: "150px" }}>
      <p className="offers-title">Opt-In</p>
      <MultiSelectDropdown
        options={options}
        selectedFilters={selected}
        numberDisplayed={0}
        includeSelectAll
        enableOnly
        onSelectChange={(data) => dispatch(actionCreators.setOptInFilters(data))}
      />
    </div>
  ) : null;
}
